import { Component, OnInit, ViewChild } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { PopulateService } from '../../../core/services/populate.service';
import { ComboGrupo, ComboCliente } from '../../../core/model/combos';
import { first } from 'rxjs/operators';
import { AbsorcionGrupoService } from '../../../core/services/absorcion-grupo.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { Page } from '../../../core/model/page';
import { AbsorcionesGrupo } from '../../../core/model/absorciones-grupo';
import { IPagination } from '../../../core/model/pagination';

@Component({
  selector: 'app-absorcion-grupo',
  templateUrl: './absorcion-grupo.component.html',
  styleUrls: ['./absorcion-grupo.component.css'],
  animations: [
    trigger('slideInOut', [
      state('open', style({
        opacity: 1,
        transform: 'scaleY(1)',
        // padding: '10px',
      })),
      state('close', style({
        opacity: 0,
        transform: 'scaleY(0)',
        // padding: '0px',
      })),
      transition('open => close', animate('300ms ease-in-out')),
      transition('close => open', animate('300ms ease-in-out'))
    ]),
    trigger('hiddenContainer', [
      state('open', style({
        height: '*',
        // padding: '10px'
      })),
      state('close', style({
        height: '0',
        // padding: '0px'
      })),
      transition('open => close', animate('300ms ease-in-out')),
      transition('close => open', animate('300ms ease-in-out'))
    ])
  ]
})
export class AbsorcionGrupoComponent implements OnInit {
  @ViewChild('tableAbsorptions') table: DatatableComponent;
  openState = 'close';
  isDocoutUser: boolean;
  cliente: number = null;

  cbGrupo: ComboGrupo[];
  cbGrupoDestino: ComboGrupo[];
  cbCliente: ComboCliente[];

  grupoAbsorbido: number;
  grupoDestino: number;

  isAdmin: boolean;

  allAbsorptions: AbsorcionesGrupo[] = undefined;

  showAbsorptions = false;
  loadingAbsorptions = false;
  savingGroups = false;
  hasBeenInitialize = false;

  page = new Page();

  // ngx-datatable options
  customMessages = {
    emptyMessage: 'No hay usuarios disponibles',
    totalMessage: 'Total',
    selectedMessage: 'Selección'
  };
  customClasses = {
    sortAscending: 'fa fa-sort-asc',
    sortDescending: 'fa fa-sort-desc',
    pagerLeftArrow: 'fa fa-chevron-left',
    pagerRightArrow: 'fa fa-chevron-right',
    pagerPrevious: 'fa fa-step-backward',
    pagerNext: 'fa fa-step-forward'
  };

  constructor(private authService: AuthenticationService,
    private populateService: PopulateService,
    private absorcionGrupoService: AbsorcionGrupoService,
    private toastr: ToastrService,
    private translateService: TranslateService) { }

  ngOnInit() {

    this.authService.isAdminUserObs().subscribe(admin => {
      this.isAdmin = admin;
    });

    this.authService.isDocOutUser()
      .then((isDocUser: boolean) => {
        this.isDocoutUser = isDocUser;
      });

    this.page.pageNumber = 0;
    this.page.size = 10;
  }
  private getClients() {
    this.populateService.getComboCliente()
      .pipe(first()).subscribe(
        clientes => {
          this.cbCliente = clientes;
        });
  }

  private initializeData() {
    if (!this.isDocoutUser) {
      this.getComboGrupo();
    } else {
      this.getClients();
    }
    this.hasBeenInitialize = true;
   }

  changeClient() {
    this.grupoAbsorbido = null;
    this.grupoDestino = null;
    this.allAbsorptions = undefined;

    if (this.showAbsorptions) {
      this.getAllAbsorptions();
    }

    this.getComboGrupo();
   }

  private getComboGrupo() {
    this.populateService.getComboGrupoByCliente(+this.cliente)
      .pipe(first()).subscribe(
        grupo => {
          this.cbGrupo = grupo;
        });
  }

  toggleBody() {
    if (!this.hasBeenInitialize) {
      this.initializeData();
    }
    this.openState = this.openState == 'open' ? 'close' : 'open';
  }


  setGruposAbsorber() {
    this.cbGrupoDestino = this.cbGrupo.filter(x => x.Id != this.grupoAbsorbido);
    this.grupoDestino = null;
  }

  absorbGroup() {
    this.savingGroups = true;
    this.absorcionGrupoService.absorbGroup(this.grupoAbsorbido, this.grupoDestino, +this.cliente)
      .pipe(first()).subscribe(success => {
        this.savingGroups = false;

        const hasError = this.authService.checkGeneralError(success);
        if (!hasError) {
          if (success == 1) {
            this.allAbsorptions = undefined;
            this.putToastSuccess('groupAbsorption.successAbsorption');
            return;
          }

          this.putToastInfo('groupAbsorption.noExistRecordsAbsorption');
        }
      },
        error => {
          this.putToastError('groupAbsorption.errorAbsorption');
          this.savingGroups = false;
        });
  }
  private putToastSuccess(key: string) {
    this.toastr.success(this.translateService.instant(key));
  }

  private putToastInfo(key: string) {
    this.toastr.info(this.translateService.instant(key));
  }

  private putToastError(key: string) {
    this.toastr.error(this.translateService.instant(key));
  }

  toggleShowAbsorptions() {
    this.showAbsorptions = !this.showAbsorptions;
    if (this.allAbsorptions === undefined && this.showAbsorptions) {
      this.getAllAbsorptions();
    }
  }

  changePage(pageInfo: any) {
    this.page.pageNumber = pageInfo.offset;
    this.getAllAbsorptions();
  }

  private getAllAbsorptions() {
    const inicio = this.page.size * this.page.pageNumber;
    const fin = inicio + this.page.size;
    this.getPaginationData(inicio, fin);
  }

  private getPaginationData(inicio: number, fin: number) {
    this.loadingAbsorptions = true;
    this.absorcionGrupoService.getAllAbsorptions(+this.cliente, inicio, fin)
      .subscribe((value: IPagination<AbsorcionesGrupo>) => {
        this.allAbsorptions = value.dataList;
        this.page.totalElements = value.totalResults;
        this.loadingAbsorptions = false;
      },
        error => {
          this.loadingAbsorptions = false;
        });
  }

  onResizedTable(event) {
    if (this.table) {
      setTimeout(() => {
        this.table.recalculate();
        window.dispatchEvent(new Event('resize'));
      }, (50));
    }
  }

  revertAbsorption(row: AbsorcionesGrupo) {
    this.absorcionGrupoService.deleteAbsorption(row.id)
      .pipe(first()).subscribe(success => {
        if (success == 1) {
          this.putToastSuccess('groupAbsorption.successAbsorptionRemoved');
          this.getAllAbsorptions();
          return;
        }

        this.putToastInfo('groupAbsorption.errorAbsorptionRemoved');
      },
        error => {
          this.putToastError('groupAbsorption.errorAbsorptionRemoved');
        });
   }


}
